import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle, Copy } from 'lucide-react';
import { toast } from 'sonner';

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  trackingNumber: string;
}

export function SuccessDialog({ open, onClose, trackingNumber }: SuccessDialogProps) {
  const handleCopy = () => {
    navigator.clipboard.writeText(trackingNumber);
    toast.success('تم نسخ رقم التتبع');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
              <CheckCircle className="h-10 w-10 text-success" />
            </div>
            <DialogTitle className="text-2xl">تم إنشاء الشحنة بنجاح!</DialogTitle>
          </div>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <div className="text-center">
            <p className="text-sm text-muted-foreground mb-2">رقم التتبع</p>
            <div className="flex items-center justify-center gap-2 bg-muted p-4 rounded-lg">
              <code className="text-lg font-mono font-bold">{trackingNumber}</code>
              <Button
                onClick={handleCopy}
                variant="ghost"
                size="icon"
                className="h-8 w-8"
              >
                <Copy className="h-4 w-4" />
              </Button>
            </div>
          </div>

          <div className="bg-primary/5 p-4 rounded-lg">
            <p className="text-sm text-center">
              يمكنك تتبع الشحنة باستخدام رقم التتبع من صفحة الشحنات
            </p>
          </div>

          <div className="flex gap-3">
            <Button onClick={onClose} className="flex-1">
              إغلاق
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
